export const extension = attrs => ({
  type: 'extension',
  attrs
});